import theme from './themeImport'

const fontSizes = {
    small_12px: theme.fontSizes.xxxs,
}

export default fontSizes
